import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import details from '../../img/details.svg';
import add from '../../img/add.svg';
import sortasc from '../../img/sort-asc.svg';
import sortdesc from '../../img/sort-desc.svg';
import user from  '../../img/user.svg';
import link from  '../../img/link.svg';
import checkmark from  '../../img/check-mark.svg';


export default class SupervisorsScreen extends React.Component {
    constructor(props) {
        super(props);

        var sortField = null
        var sortOrder = null
        var nameCriteria = ""
        var selectedRegionId = ""

    
        const args = props.args === undefined ? {} : props.args
        
        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        if (args.nameCrieria !== undefined) {
            nameCriteria = args.nameCrieria
        }

        if (args.selectedRegionId !== undefined) {
            selectedRegionId = args.selectedRegionId
        }

        

        this.state = {
              args: args, 
              nameCriteria: nameCriteria,
              regionOptions: [],
              selectedRegionId: selectedRegionId,
              prevNameCriteria: "",
              supervisors: [],
              sortField: sortField, 
              sortOrder: sortOrder  
        }

        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this); 
        this.regionChangeHandler = this.regionChangeHandler.bind(this); 
        this.sortClicked = this.sortClicked.bind(this);   
        this.nameSearch = this.nameSearch.bind(this);   
        
        setTimeout(this.nameSearch, 2000);

    }  
    
    async componentDidMount() {
        this.getDataWithCriteria()
        this.getRegionOptons()
    }

    getDataWithCriteria() {
        var parameters = {}
        
        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.regionId = this.state.selectedRegionId

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

    
        BaseApi.get('/supervisors', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({supervisors: res.data})
        })    
        .catch(error=>console.log(error))
    }


    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCriteria)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "regionCaption" :
                if (currentField === "region") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "region"
                    currentOrder = "asc"
                }
            break
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break         
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCriteria)
    }

    nameCriteriaChangeHandler(event) {
        var args = this.state.args
        args.nameCriteria = event.target.value
        this.setState({nameCriteria: event.target.value, args: args})
    }

    getRegionOptons() {
            BaseApi.get("/regions", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
            .then(res => {
                const regionOptions = res.data.map(({id, name}) => ({value: id, label: name}))
                regionOptions.push({value: "", label: "Все"})
                this.setState({regionOptions: regionOptions})
            })    
            .catch()
        }

    regionChangeHandler(selectedOption) {
        var args = this.state.args
        args.selectedRegionId = selectedOption.value
        this.setState({selectedRegionId: selectedOption.value, args: args}, this.getDataWithCriteria)
    }

    openSupervisor(id) {
        this.props.navigate("supervisor", {caller: "supervisors", callargs: this.state.args, supervisor: id})
    }

    createUser(supervisor) {
        this.props.navigate("user", {caller: "supervisors", callargs: this.state.args, userid: supervisor.userid, refid: supervisor.id, personname: supervisor.name, email: supervisor.email, role: "supervisor"})
    }

    renderSupervisor(supervisor) {
        return (
            <tr 
                key={supervisor.id}
                className="table-row-clickable"
                onClick={() => this.openSupervisor(supervisor.id)}
            >
                  
                <td style={{textAlign: 'left',  padding: '4px'}}>{supervisor.region}</td>
                        
                <td style={{textAlign: 'left',  padding: '4px'}}>{supervisor.name}</td>
                {supervisor.userid === null &&
                    <td 
                        style={{textAlign: 'center'}}
                    >
                        <button class="btn btn-outline-success btn-sm"
                            onClick={(e) =>
                            {
                                    e.stopPropagation();   
                                    this.createUser(supervisor)
                            }}
                        >
                            <i class="bi bi-person-plus"></i>
                        </button>
                    </td>
                }  
                {supervisor.userid !== null &&
                    <td style={{textAlign: 'center'}}>
                        <button class="btn btn-outline-primary btn-sm"
                            onClick={(e) =>
                            {
                                e.stopPropagation();   
                                this.createUser(supervisor)
                            }}
                        >
                            <i class="bi bi-person-badge"></i>
                        </button>                            
                    </td>
                }    
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Кураторы"}/>

                <div className="row mt-4 mb-3">
                    <div className="col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>
                                <div className="mb-3">
                                    <label for="name"> Имя:</label>
                                    <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} /> 
                                </div>
                                <div className="mb-3">
                                    <label for="region">Регион:</label>
                                    <Select options= {this.state.regionOptions} 
                                            id="region" 
                                            value={this.state.regionOptions.find(o => o.value == this.state.selectedRegionId)}
                                            onChange={this.regionChangeHandler}
                                            />  
                                </div>
                            </div>
                        </div>
                    </div>   

                     <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={() => this.openSupervisor("")}
                            >
                                Добавить куратора
                            </button>
                        </div>
                    </div> 
                </div>


                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th id="regionCaption"
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            onClick={this.sortClicked}>
                                            Регион
                                            {this.isFieldSortedDesc("region") && <img src={sortdesc} height="16" width="16"/>}
                                            {this.isFieldSortedAsc("region") && <img src={sortasc} height="16" width="16"/>}
                                        </th>
                                        <th id="nameCaption"
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            onClick={this.sortClicked}>
                                            Имя
                                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                                        </th>  
                                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Аккаунт
                                        </th>    

                                    </tr>

                                </thead>
                                <tbody>
                                    {this.state.supervisors.map((value, index) => this.renderSupervisor(value))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/*
                <div class="row mt-5" style={{"height" : "50px"}}>  
                    <div class="col-3 text-left border border-white"
                        id="regionCaption"
                        style={{"background-color" : "#0ee"}}
                        onClick={this.sortClicked}>
                        Регион
                        {this.isFieldSortedDesc("region") && <img src={sortdesc} height="16" width="16"/>}
                        {this.isFieldSortedAsc("region") && <img src={sortasc} height="16" width="16"/>}
                    </div>
                    <div class="col-3 text-left border border-white"
                        id="nameCaption"
                        style={{"background-color" : "#0ee"}} 
                        onClick={this.sortClicked}>
                            Имя
                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                    </div>  
                    <div class="col-1 border border-white"
                        style={{"background-color" : "#0ee"}}
                        onClick={()=>{this.openSupervisor("")}}><img src={add} height="16" width="16"/>
                    </div>  
                    <div class="col-1 border border-white"
                        style={{"background-color" : "#0ee"}}>
                        <img src={user} height="16" width="16"/>
                    </div>    
                </div>    
                
            
                {this.state.supervisors.map((value, index) => this.renderSupervisor(value))}
                */}
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/supervisors.js